export const buildEmptyPlan = () => ({
  _id: "",
  code: "",
  name: "",
  description: "",
  currency: "INR",
  billing_period: "monthly",
  actual_price: "",
  offer_price: "",
  duration_days: "",
  included_test_count: "",
  included_subscription_ai_credits: "",
  discount_percentage: "",
  maximum_discount_per_order: "",
  maximum_discount_during_subscription: "",
  refund_policy: "",
  terms_version: "v1",
  feature_list: "",
  eligible_test_types: "mock_test,practice_test,live_test,test_series",
  excluded_categories: "",
  display_order: "",
  payment_provider: "razorpay",
  provider_product_ids: {
    web: "",
    android: "",
    ios: "",
  },
  is_visible: true,
  is_active: false,
  is_recommended: false,
  excluded_premium_tests: false,
  allow_discount_on_live_tests: true,
  allow_discount_on_already_discounted_tests: false,
  allow_coupon_stacking: false,
});

export const planScalarFields = [
  ["code", "Plan Code"],
  ["name", "Plan Name"],
  ["description", "Description"],
  ["currency", "Currency"],
  ["actual_price", "Actual Price"],
  ["offer_price", "Offer Price"],
  ["duration_days", "Duration Days"],
  ["included_test_count", "Included Tests"],
  ["included_subscription_ai_credits", "Subscription AI Credits"],
  ["discount_percentage", "Discount %"],
  ["maximum_discount_per_order", "Max Discount Per Order"],
  ["maximum_discount_during_subscription", "Max Total Discount"],
  ["refund_policy", "Refund Policy"],
  ["terms_version", "Terms Version"],
  ["feature_list", "Feature List (comma separated)"],
  ["eligible_test_types", "Eligible Test Types (comma separated)"],
  ["excluded_categories", "Excluded Categories (comma separated)"],
  ["display_order", "Display Order"],
  ["payment_provider", "Payment Provider"],
];

export const billingPeriodOptions = [
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "half_yearly", label: "Half Yearly" },
  { value: "yearly", label: "Yearly" },
  { value: "custom", label: "Custom" },
];

export const planToggleFields = [
  ["is_visible", "Visible"],
  ["is_active", "Active"],
  ["is_recommended", "Recommended"],
  ["excluded_premium_tests", "Exclude Premium Tests"],
  ["allow_discount_on_live_tests", "Discount on Live Tests"],
  ["allow_discount_on_already_discounted_tests", "Allow Discount on Discounted Tests"],
  ["allow_coupon_stacking", "Allow Coupon Stacking"],
];

export const normalizeNumber = (value) => {
  if (value === "" || value === null || value === undefined) {
    return 0;
  }
  return Number(value) || 0;
};

export const mapPlanToForm = (plan) => ({
  _id: plan?._id || "",
  code: plan?.code || "",
  name: plan?.name || "",
  description: plan?.description || "",
  currency: plan?.currency || "INR",
  billing_period: plan?.billing_period || "monthly",
  actual_price: plan?.actual_price ?? "",
  offer_price: plan?.offer_price ?? "",
  duration_days: plan?.duration_days ?? "",
  included_test_count: plan?.included_test_count ?? "",
  included_subscription_ai_credits: plan?.included_subscription_ai_credits ?? "",
  discount_percentage: plan?.discount_percentage ?? "",
  maximum_discount_per_order: plan?.maximum_discount_per_order ?? "",
  maximum_discount_during_subscription: plan?.maximum_discount_during_subscription ?? "",
  refund_policy: plan?.refund_policy || "",
  terms_version: plan?.terms_version || "v1",
  feature_list: Array.isArray(plan?.feature_list) ? plan.feature_list.join(", ") : "",
  eligible_test_types: Array.isArray(plan?.eligible_test_types)
    ? plan.eligible_test_types.join(", ")
    : "",
  excluded_categories: Array.isArray(plan?.excluded_categories)
    ? plan.excluded_categories.join(", ")
    : "",
  display_order: plan?.display_order ?? "",
  payment_provider: plan?.payment_provider || "razorpay",
  provider_product_ids: {
    web: plan?.provider_product_ids?.web || "",
    android: plan?.provider_product_ids?.android || "",
    ios: plan?.provider_product_ids?.ios || "",
  },
  is_visible: Boolean(plan?.is_visible),
  is_active: Boolean(plan?.is_active),
  is_recommended: Boolean(plan?.is_recommended),
  excluded_premium_tests: Boolean(plan?.excluded_premium_tests),
  allow_discount_on_live_tests: Boolean(plan?.allow_discount_on_live_tests),
  allow_discount_on_already_discounted_tests: Boolean(
    plan?.allow_discount_on_already_discounted_tests
  ),
  allow_coupon_stacking: Boolean(plan?.allow_coupon_stacking),
});

export const buildPlanPayload = (planForm) => ({
  code: planForm.code,
  name: planForm.name,
  description: planForm.description,
  currency: planForm.currency,
  billing_period: planForm.billing_period,
  actual_price: normalizeNumber(planForm.actual_price),
  offer_price: normalizeNumber(planForm.offer_price),
  duration_days: normalizeNumber(planForm.duration_days),
  included_test_count: normalizeNumber(planForm.included_test_count),
  included_subscription_ai_credits: normalizeNumber(
    planForm.included_subscription_ai_credits
  ),
  discount_percentage: normalizeNumber(planForm.discount_percentage),
  maximum_discount_per_order: normalizeNumber(planForm.maximum_discount_per_order),
  maximum_discount_during_subscription: normalizeNumber(
    planForm.maximum_discount_during_subscription
  ),
  refund_policy: planForm.refund_policy,
  terms_version: planForm.terms_version,
  feature_list: planForm.feature_list,
  eligible_test_types: planForm.eligible_test_types,
  excluded_categories: planForm.excluded_categories,
  display_order: normalizeNumber(planForm.display_order),
  payment_provider: planForm.payment_provider,
  provider_product_ids: {
    web: planForm.provider_product_ids.web,
    android: planForm.provider_product_ids.android,
    ios: planForm.provider_product_ids.ios,
  },
  is_visible: Boolean(planForm.is_visible),
  is_active: Boolean(planForm.is_active),
  is_recommended: Boolean(planForm.is_recommended),
  excluded_premium_tests: Boolean(planForm.excluded_premium_tests),
  allow_discount_on_live_tests: Boolean(planForm.allow_discount_on_live_tests),
  allow_discount_on_already_discounted_tests: Boolean(
    planForm.allow_discount_on_already_discounted_tests
  ),
  allow_coupon_stacking: Boolean(planForm.allow_coupon_stacking),
});
